import { render, staticRenderFns } from "./LocaleSwitch.vue?vue&type=template&id=6c45d765&scoped=true"
import script from "./LocaleSwitch.vue?vue&type=script&lang=js"
export * from "./LocaleSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c45d765",
  null
  
)

export default component.exports